import type { Video } from '@getaccept/lib-shared/src/types/Video';
import type { NodeUpdatePayload } from '../types';

export class VideoBlockHelper {
  static convertPayload(video: Video, imagePayload: NodeUpdatePayload): NodeUpdatePayload {
    return {
      url: video?.videoUrl,
      attribution: {
        url: video?.thumbUrl || '',
        name: '',
      },
      srcUrl: imagePayload?.srcUrl,
      videoId: video?.id,
    };
  }
}
